module.exports = __webpack_public_path__ + "img/pharmaSmart.7018fe38.png";